import useShopifySubscription from 'hooks/billing/useShopifySubscription';
import { AppRecurringPricingDetails } from 'hooks/shopify/queries/get-all-app-subscriptions.graphql';
import { useMemo } from 'react';
import { useAppSelector } from 'redux/hooks';
import { selectShopifyAppPlansFetching } from 'redux/slices/shopify-app-pricing/shopify-app-pricing.selector';

interface PlanHandle {
    /** Handle of the current subscription's pricing plan; `undefined` for a legacy subscription, without a subscription, or while loading */
    planHandle: string | undefined;
    /** True until both the Shopify plans and the current subscription have resolved */
    isLoading: boolean;
}

/**
 * The current plan handle on its own, for consumers like `useSendGTMAction` that must not depend on
 * `useCurrentSubscriptionHelper` (which itself sends GTM events).
 */
const usePlanHandle = (): PlanHandle => {
    const plansFetching = useAppSelector(selectShopifyAppPlansFetching);
    const { currentSubscription, isLoading: subscriptionFetching } = useShopifySubscription();

    const planHandle = useMemo(
        () => (currentSubscription?.lineItems?.[0]?.plan?.pricingDetails as AppRecurringPricingDetails)?.planHandle,
        [currentSubscription]
    );

    return { planHandle, isLoading: plansFetching || subscriptionFetching };
};

export default usePlanHandle;
